import {call, put, select, takeEvery} from "redux-saga/effects";
import {AnyAction} from "redux";
import * as _ from "lodash";
import {SET_SELECTED_POWER_SOURCE, SET_SELECTED_LOCATION, REMOVE_POWER_SOURCE, PLACE_POWER_SOURCE, ADD_POWER_SOURCE_AT_LOCATION} from "../actions/action";
import {getPowerSources} from "../reducers/powerSources";
import {getPowerSourceDataByID, getPowerSourceLocationData, IPowerSource, IPowerSourceLocation} from "../../data/data";
import {getSelectedLocation, isLocationValidForDraggingPowerSource} from "../reducers/location";
import {hideModal, showPowerSourceDetailsModal} from "../actions/modals";
import {hidePopup, showAddPowerSourcePopup} from "../actions/popups";
import {addPowerSourceAtLocation, setDraggingPowerSource} from "../actions/powerSources";
import {clearSelectedLocation, setHighlightLocation} from "../actions/locations";
import {getDraggingPowerSource} from "../reducers/draggingPowerSource";
import {getHighlightLocation, getHighlightLocationData} from "../reducers/highlightLocation";
import {isYearAlreadyComplete} from '../reducers/calendar/isYearAlreadyComplete';
import {endYear, testAnnualTargets} from '../actions/calendar/year';
import {delay} from 'redux-saga';


/**
 * watch for relevant actions
 */
export default function* handleSelectedLocation()
{
    yield takeEvery(SET_SELECTED_LOCATION, onSelectedLocationChange);
    yield takeEvery(SET_SELECTED_POWER_SOURCE, onPowerSourceSelection);
    yield takeEvery(PLACE_POWER_SOURCE, onPowerSourcePlace);
    yield takeEvery(REMOVE_POWER_SOURCE, onPowerSourceRemoval);
}


/**
 * when the user wants to merge a mutation into the config, capture and store the mutation
 * @param {AnyAction} action
 */
function* onSelectedLocationChange(action: AnyAction)
{
    //  get the selected location

    const location_id: number = yield select(getSelectedLocation);
    const power_sources: IPowerSource[] = yield select(getPowerSources);

    // console.group('onSelectedLocationChange');
    // console.log('location_id', location_id);
    // console.log('power_sources', power_sources);
    // console.groupEnd();

    const source_at_location: IPowerSource = power_sources[location_id];

    //  is there already a source at this location?

    if (source_at_location)
    {
        yield put(showPowerSourceDetailsModal());
    }
    else
    {
        const location: IPowerSourceLocation = getPowerSourceLocationData(location_id);

        yield put(showAddPowerSourcePopup(location.position[0], location.position[1]));
    }
}



/**
 * when the user wants to merge a mutation into the config, capture and store the mutation
 * @param {AnyAction} action
 */
function* onPowerSourceSelection(action: AnyAction)
{
    //  get the power source from the action

    const {payload} = action;
    const {power_source} = payload;

    //  get the selected location

    const location_id: number = yield select(getSelectedLocation);

    // console.group('onPowerSourceSelection');
    // console.log('location_id', location_id);
    // console.log('power_source', power_source);
    // console.groupEnd();

    //  add the power source at the selected location

    yield put(addPowerSourceAtLocation(power_source, location_id));

    //  de-select the location

    yield put(clearSelectedLocation());

    //  hide the popup

    yield put(hidePopup());
}





/**
 * when the user removes a power source, hide the modal
 * @param {AnyAction} action
 */
function* onPowerSourcePlace(action: AnyAction)
{
    //  get the power source from the action

    const power_source: IPowerSource = yield select(getDraggingPowerSource);
    const location: IPowerSourceLocation = yield select(getHighlightLocationData);
    const location_id: number = yield select(getHighlightLocation);
    const is_valid: boolean = yield select(isLocationValidForDraggingPowerSource, location_id);

    // console.group();
    // console.log('power_source', power_source);
    // console.log('location', location);
    // console.log('location_id', location_id);
    // console.log('is_valid', is_valid);
    // console.groupEnd();

    if (_.isFinite(location_id) && location_id !== -1 && is_valid)
    {
        //  get location-specific variant of the power source type,
        //  eg sea/land wind-farm

        let specific_power_source: IPowerSource;

        switch (power_source.id)
        {
            case 'wind':

                specific_power_source = location.type !== 'sea' ? power_source : getPowerSourceDataByID('wind-sea');

                break;

            default:

                specific_power_source = power_source;

                break;
        }

        //  add the power source at the selected location

        if (specific_power_source && !!~location_id) yield put(addPowerSourceAtLocation(specific_power_source, location_id));
    }

    yield put(setDraggingPowerSource());
    yield put(setHighlightLocation());

    yield call(delay, 500);

    yield put(testAnnualTargets());
}




/**
 * when the user removes a power source, hide the modal
 * @param {AnyAction} action
 */
function* onPowerSourceRemoval(action: AnyAction)
{
    yield put(hideModal());
    yield put(testAnnualTargets());
}






// WEBPACK FOOTER //
// ./src/ts/store/sagas/handleLocationInteractions.ts